import ServiceBus from "servicestack/service-bus";
import basicController from "servicestack/basic.controller.properties";
import modals from "webmodals/modals";
import $session from "servicestack/session";
import AutoQuery from 'servicestack/auto-query/auto-query.es6'

// import moment from "moment";

export default class RepAssignmentPromptController {
	constructor(options) {
		const $ctrl = this;
		basicController($ctrl);
		const {
			request = options.assignment,
			title
		} = options;
		console.info("options", options);
		$ctrl.request = {
			id: request.id,
			originalRep: request.originalRep,
			newRep: request.newRep,
			effectiveOn: moment(request.effectiveOn),
			effectiveOnMoment: moment(request.effectiveOn).format("MM/DD/YYYY")
		};
		$ctrl.originalRepModel = {
			id: request.originalRep,
			name: request.currentRepName
		};
		$ctrl.newRepModel = {
			id: request.newRep,
			name: request.salesRepName
		};


		$ctrl.action = request.id ? "Update" : "Create";
		$ctrl.bus = new ServiceBus();
		$ctrl.title = title || `${$ctrl.action} Rep Assignment...`;
	}

	$onInit() {
		const $ctrl = this;
	}

	submit() {
		const $ctrl = this;
		$ctrl.bus
			.send(`${$ctrl.action}RepAssignment.json`, $ctrl.request)
			.then(function (response) {
				$ctrl.$emit("repassignmentSaved", $ctrl);
				$ctrl.$emit("refresh-repassignments", response);
				$ctrl.$close(response.data);
			});
	}
	delete() {
		const $ctrl = this;
		$ctrl.$close($ctrl.request);

		//return modals
		//  .confirm("Are you sure?", "Delete Quick Report")
		//  .result.then(function() {
		//    $ctrl.bus
		//      .send("DeleteQuickReport.json", $ctrl.request)
		//      .then(function(response) {
		//        $ctrl.$emit("quickReportDeleted", $ctrl);
		//        $ctrl.$emit("refresh-quick-report", response);
		//      });
		//  });
	}


	dismiss() {
		const $ctrl = this;
		//$ctrl.$emit('listSaved', $ctrl);
		$ctrl.$dismiss();
	}
}
